"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TimelineCard = _interopRequireDefault(require("./TimelineCard"));

var _ExpandLessRounded = _interopRequireDefault(require("@material-ui/icons/ExpandLessRounded"));

var _ExpandMoreRounded = _interopRequireDefault(require("@material-ui/icons/ExpandMoreRounded"));

var _OneDashCards = require("../OneDashCards");

var _reactPose = _interopRequireDefault(require("react-pose"));

require("../../assets/css/components/timeline.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Content = _reactPose["default"].div({
  closed: {
    height: 0,
    overflow: "hidden",
    marginTop: "2rem"
  },
  open: {
    height: "auto"
  }
});

function TransactionTimeline(_ref) {
  var data = _ref.data,
      children = _ref.children;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      toggleOpen = _useState2[1];

  return _react["default"].createElement(_OneDashCards.Card, null, _react["default"].createElement("div", {
    className: open ? "kt-timeline-v2 kt-timeline-v2-before" : "kt-timeline-v2"
  }, open ? _react["default"].createElement("a", null, _react["default"].createElement(_ExpandLessRounded["default"], {
    className: "kt-expand-icon",
    onClick: function onClick() {
      return toggleOpen(!open);
    }
  })) : _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("a", {
    className: "kt-open-close"
  }, _react["default"].createElement("span", {
    className: "viewKt"
  }, "view timeline"), _react["default"].createElement(_ExpandMoreRounded["default"], {
    className: "kt-expand-icon",
    onClick: function onClick() {
      return toggleOpen(!open);
    }
  }))), _react["default"].createElement("div", {
    className: "kt-timeline-v2__items  kt-padding-top-25 kt-padding-bottom-30"
  }, data.length > 0 && _react["default"].createElement(_TimelineCard["default"], {
    key: 0,
    title: data[0].title,
    body: data[0].body,
    timeStamp: !open ? "" : data[0].timeStamp,
    icon: data[0].icon,
    className: !open ? "kt-no-margin-bottom" : ""
  }), _react["default"].createElement(Content, {
    className: "content",
    pose: open ? "open" : "closed"
  }, data.map(function (d, i) {
    return i > 0 && _react["default"].createElement(_TimelineCard["default"], {
      key: i,
      title: d.title,
      body: d.body,
      timeStamp: d.timeStamp,
      icon: d.icon
    });
  })))), children);
}

TransactionTimeline.propTypes = {
  data: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    title: _propTypes["default"].string,
    body: _propTypes["default"].string,
    iconType: _propTypes["default"].string,
    timeStamp: _propTypes["default"].string
  })),
  children: _propTypes["default"].node
};
TransactionTimeline.defaultProps = {
  data: [],
  children: ""
};
var _default = TransactionTimeline;
exports["default"] = _default;